import { render, staticRenderFns } from "./CarouselMain.vue?vue&type=template&id=20b95b83&scoped=true&"
import script from "./CarouselMain.vue?vue&type=script&lang=js&"
export * from "./CarouselMain.vue?vue&type=script&lang=js&"
import style0 from "./CarouselMain.vue?vue&type=style&index=0&id=20b95b83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b95b83",
  null
  
)

export default component.exports